import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css"; // ensure global styles are loaded (index.js likely already does this; safe to keep)

/* page container: use .home-no-scroll so root never creates a browser scrollbar */
const Home = () => {
  return (
    <div className="home-no-scroll">
      {/* HERO SECTION */}
      <section className="bg-primary text-white text-center py-2 py-md-3">
        <div className="container">
          <h1 className="fw-bold display-6 display-md-5">Welcome to Autotronics</h1>
          <p className="lead mt-2 fs-6 fs-md-5">
            Smart engineering and customer services department tracking, performance insights & business analytics
          </p>
        </div>
      </section>

      {/* FEATURES */}
      <section className="home-features py-2">
        <div className="container">
          <h2 className="text-center fw-bold">Our Features</h2>

          <div className="row g-4">
            <div className="col-12 col-sm-6 col-lg-4">
              <Link to="/v4" className="text-decoration-none text-reset" aria-label="Engineer Tracking - Login">
                <div
                  className="card h-100 shadow-sm text-center p-3 d-flex flex-column justify-content-between align-items-center"
                  role="button"
                  style={{ cursor: "pointer", transition: "transform .15s ease, box-shadow .15s ease" }}
                >
                  <div>
                    <h5 className="fw-bold">Engineer Tracking</h5>
                    <p className="text-muted mb-0">
                      Track engineer performance and activities in real time.
                    </p>
                  </div>
                  <small className="text-muted mt-3 d-none d-md-block">Click to sign in and view engineers</small>
                </div>
              </Link>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <Link to="/v3" className="text-decoration-none text-reset" aria-label="Engineering Department">
                <div
                  className="card h-100 shadow-sm text-center p-3 d-flex flex-column justify-content-between align-items-center"
                  role="button"
                  style={{ cursor: "pointer", transition: "transform .15s ease, box-shadow .15s ease" }}
                >
                  <div>
                    <h5 className="fw-bold">Engineering Department</h5>
                    <p className="text-muted mb-0">
                      Track engineering department performance and activities in real time.
                    </p>
                  </div>
                  <small className="text-muted mt-3 d-none d-md-block">Department overview</small>
                </div>
              </Link>
            </div>

            <div className="col-12 col-sm-6 col-lg-4">
              <Link to="/v1" className="text-decoration-none text-reset" aria-label="Customer Services Department">
                <div
                  className="card h-100 shadow-sm text-center p-3 d-flex flex-column justify-content-between align-items-center"
                  role="button"
                  style={{ cursor: "pointer", transition: "transform .15s ease, box-shadow .15s ease" }}
                >
                  <div>
                    <h5 className="fw-bold">Customer Services Department</h5>
                    <p className="text-muted mb-0">
                      Track customer services department performance and activities in real time.
                    </p>
                  </div>
                  <small className="text-muted mt-3 d-none d-md-block">Customer services overview</small>
                </div>
              </Link>
            </div>
            <div className="col-12 col-sm-6 col-lg-4">
              <Link to="/v6" className="text-decoration-none text-reset" aria-label="Categories Department">
                <div
                  className="card h-100 shadow-sm text-center p-3 d-flex flex-column justify-content-between align-items-center"
                  role="button"
                  style={{ cursor: "pointer", transition: "transform .15s ease, box-shadow .15s ease" }}
                >
                  <div>
                    <h5 className="fw-bold">Categories Department</h5>
                    <p className="text-muted mb-0">
                      Track categories performance and activities in real time.
                    </p>
                  </div>
                  <small className="text-muted mt-3 d-none d-md-block">Categories overview</small>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <footer className="bg-dark text-white text-center py-3 mt-auto">
        <div className="container">
          <p className="mb-0 small">© {new Date().getFullYear()} Autotronics. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
